/**
 * 计算页面头部高度
 * @param {Object} options - 配置选项
 * @param {boolean} options.hasBannerAd - 是否有顶部广告
 * @param {boolean} options.hasBannerNotice - 是否有顶部公告
 * @returns {number} 计算后的头部高度
 */
export function calculateHeaderHeight({
  hasBannerAd = false,
  hasBannerNotice = false,
} = {}) {
  // 计算 banner 高度
  const bannerHeight = hasBannerAd || hasBannerNotice ? 60 : 0;
  // 根据实验组判断 headerBar 高度
  const headerBarHeight = 80;

  // 总高度 = banner高度 + headerBar高度
  return bannerHeight + headerBarHeight;
}
